import React, { useContext } from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core'
import styled from 'styled-components/macro';
import {deleteUnit, fetchUnits} from '../../../redux/actions/unitsActions';
import { clearA11yes, fetchA11yes } from '../../../redux/actions/a11yesActions';
import * as Icon from "react-feather";
import { UnitsContext } from '../../../components/contexts/UnitsContext';
import { useDispatch, useSelector } from 'react-redux';
import { AccessibilityUnit } from '../../../models/AccessibilityUnits';
import { AppStateType } from '../../../redux/reducers';
import { useRouteMatch } from 'react-router-dom';
import {getTextByCurrentLanguage, scrollToElement} from '../../../utils/functions';
import Swal from "sweetalert2";
import {useTranslation} from "react-i18next";
import i18n from "i18next";

const DayText = styled.div`
    background: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;

const useStyles = makeStyles((theme) => ({
    wrapperExistingUnits: {
        cursor: "pointer",
        width: "100%",
        display: "flex",
        alignItems: "center",
        borderTop: "1px solid rgba(238, 238, 238, 0.1)"
    },
    existingUnit: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        paddingTop: '8px',
        paddingBottom: '8px'
    },
    unitName: {
        color: "white"
    },
    deleteIcon: {
        color: 'rgb(77, 96, 112)',
        marginRight: '10px'
    },
}))

const RenderChildUnits = ({
    units, handleExistingUnitClick, itemId, existingUnit
}: {
    units: AccessibilityUnit[], handleExistingUnitClick: (id: string) => Promise<void>, itemId: string, existingUnit: AccessibilityUnit
}) => {
    return <>
        {units.filter((item) => item.related_to![0] === itemId).map((item, index) => {
            return <Box
                key={index}
                style={{
                    cursor: 'pointer',
                }}
                py={2}
                pl={13}
                width="100%"
                display="flex"
                alignItems="center"
                borderTop="1px solid rgba(238, 238, 238, 0.1)"
                onClick={() => handleExistingUnitClick(item.id)}
            >
                <img src="/static/img/icons/facilityIcons/newUnitIcon.svg" alt="" />
                <Box ml={2} >
                    {existingUnit && existingUnit.id === item.id ? <DayText>{getTextByCurrentLanguage(item.name)}</DayText> : <Typography variant="body1" style={{ color: "white" }}> {getTextByCurrentLanguage(item.name)}   </Typography>}
                </Box>
            </Box>
        })}
    </>;
}

export const RenderExistingUnits = (p: {
    type: string,
    facilityIndex: number,
}) => {
    const styles = useStyles();
    const { url } = useRouteMatch();
    const { type, facilityIndex } = p;
    const units = useSelector((state: AppStateType) => state.unitsReducer.units!);
    const facilities: string[] = useSelector((state: AppStateType) => state.facilitiesReducer.facilities);
    const user = useSelector((state: AppStateType) => state.authReducer.user)!
    const dispatch = useDispatch()
    const { existingUnitState, chosenUnitState, currentUnitState } = useContext(UnitsContext)
    const [, setCurrentUnit] = currentUnitState
    const [existingUnit, setExistingUnit] = existingUnitState
    const [chosenUnit, setChosenUnit] = chosenUnitState
    const { t } = useTranslation()
    const property = useSelector((state: AppStateType) => state.propertyReducer.property)!

    const handleExistingUnitClick = async (id: string) => {
        const unit: any = units.find((unit) => unit.id === id);
        scrollToElement("app-header")

        if (unit.related_to.length > 0) {
            const parentUnit: any = units.find((u) => u.id === unit.related_to[0])
            const facilityIndex = facilities.indexOf(parentUnit.title);
            const unityIndex = units?.indexOf(parentUnit);

            setChosenUnit({
                facilitiesIndex: facilityIndex,
                unityIndex: unityIndex,
                unityId: unit.related_to.length[0]
            });
        }
        if (unit) {
            if (url.includes('classify')) {
                dispatch(fetchA11yes(unit.id, user.token))
            }
            const currentUnit = {
                name: unit.title,
                type: unit.type,
                property: unit.property
            }
            setCurrentUnit(currentUnit)
            setExistingUnit(unit)
            await dispatch(clearA11yes())
        }
    }

    const handleDeleteUnit = (id: string, index: number) => {
        const foundUnit = units.find((i) => i.id === id)
        if (foundUnit) {
            Swal.fire({
                title: t('imagesPage_Are_your_sure'),
                text: `${t('imagesPage_Delete')} '${getTextByCurrentLanguage(foundUnit.name)}'?`,
                confirmButtonText: t('imagesPage_Yes'),
                cancelButtonText: t('imagesPage_Cancel'),
                showCancelButton: true,
                reverseButtons: true,
                width: '400px'
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(deleteUnit(user.token, id))
                    // dispatch(fetchUnits(property.id, user.token))
                    setExistingUnit(null);
                }
            })
        }

    }

    const getRelatedUnits = (item: AccessibilityUnit, units: AccessibilityUnit[]) => {
        return  units.filter((i) => {
            if (i.related_to) {
                return i.related_to.find((id) => id === item.id)
            }
            return false
        })
    }

    return (
        <div>
            {units.filter((i) => i.related_to?.length === 0).map((item, index) => {
                if (item.type !== type) {
                    return null;
                }
                return (
                    <div key={index}>
                        <Box
                            style={{
                                backgroundColor: chosenUnit.facilitiesIndex === facilityIndex && chosenUnit.unityIndex === index ? '#1e293a' : ''
                            }}
                            pl={5}
                            className={styles.wrapperExistingUnits}
                        >
                            <div
                                className={styles.existingUnit}
                                onClick={() => {
                                    handleExistingUnitClick(item.id);
                                    setChosenUnit({ facilitiesIndex: facilityIndex, unityIndex: index, unityId: item.id })
                                }}
                            >
                                <img src="/static/img/icons/facilityIcons/newUnitIcon.svg" alt="" />
                                <Box ml={2} >
                                    <Typography className={styles.unitName}>
                                        {getTextByCurrentLanguage(item.name)}
                                    </Typography>
                                </Box>
                            </div>
                            <Icon.Delete
                                size={20}
                                className={styles.deleteIcon}
                                onClick={e => handleDeleteUnit(item.id, index)}
                            />
                        </Box>
                        <Box>
                            {getRelatedUnits(item, units).length > 0 && <RenderChildUnits
                              units={getRelatedUnits(item, units)}
                              handleExistingUnitClick={handleExistingUnitClick}
                              existingUnit={existingUnit!}
                              itemId={item.id}
                            />}
                        </Box>
                    </div>
                )
            })}
        </div>
    )
}